import { CompetitionBlockService } from 'src/app/core/shared/services/competition-block.service';
import { SnackbarService } from './snackbar.service';
import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MessageErrorResolver } from "../../utilities/message-error-resolver";
import { LoadingService } from "./loading.service";
import { catchError, EMPTY, finalize, map, Observable, of, switchMap, tap, throwError } from "rxjs";
import { ResponseDto } from "../../models/exceptions/response-dto";
import { AttachmentPostForm } from "../../models/form/attachment-post-form";
import { IAttachmentDto } from "../../models/portal/users/dtos/attachment-dto";
import { AttachmentUtils } from '../../utilities/attachment-utils';
import { toUrl } from '../../utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  private url: string = environment.apiUrl + "/v1/anexo";

  private readonly MAX_SIZE_MB = 2;

  constructor(
    private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService,
    private competitionBlockService: CompetitionBlockService,
    private snackbarService: SnackbarService
  ) { }

  public getAttachmentByUrl(url: string): Observable<string> {
    const params = new HttpParams().set('url', url);
    return this.httpClient.get(`${this.url}`, { params, responseType: 'blob' })
      .pipe(
        switchMap((res: Blob) => AttachmentUtils.convertBlobToBase64(res)),
      );
  }

  findAttachmentById$(aneNrId: number): Observable<string> {
    return this.httpClient.get(toUrl(this.url, aneNrId), { responseType: 'blob' })
      .pipe(
        switchMap((res: Blob) => AttachmentUtils.convertBlobToBase64(res)),
      );
  }

  public postEventAttachment(form: AttachmentPostForm, eveNrId: number): Observable<void> {
    return this.httpClient.post<void>(this.url.concat(`/evento/${eveNrId}`), form)
      .pipe(
        catchError(err => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          return EMPTY;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  public getEventAttachment(eveNrId: number, attachmentType: "CREDENCIAL" | "CERTIFICADO" | "LOGO_EVENTO"): Observable<IAttachmentDto> {
    const params: HttpParams = new HttpParams().set("tipoAnexo", attachmentType);
    return this.httpClient.get<ResponseDto<IAttachmentDto>>(this.url.concat(`/evento/${eveNrId}`), { params: params })
      .pipe(
        map(response => response.response),
        catchError(err => {
          this.loadingService.deactivate();
          return EMPTY;
        }),
      );
  }

  // isAnexoAllowedByEventDate(anexo: IAttachmentEventTypeDto, incNrId: number): Observable<boolean> {
  //   return this.competitionBlockService.buscarBlocoPorInscricao(incNrId).pipe(
  //     map((res) => {
  //       const dataFimStr = res.response.bloDtFimInscricao;
  //       if (!dataFimStr) return false;

  //       const dataFim = new Date(dataFimStr);
  //       const hoje = new Date();

  //       const eventoEncerrado = dataFim.getTime() < hoje.getTime();

  //       if (anexo.taeBlEnviarAposPeriodoInscricao) {
  //         return eventoEncerrado;
  //       }

  //       return true;
  //     }),
  //     catchError(() => of(false)) // em caso de erro, retorna false
  //   );
  // }
  getBase64OrCompressed(file: File): Observable<string> {
    const sizeInMB = file.size / (1024 * 1024);

    if (sizeInMB > this.MAX_SIZE_MB) {
      const formData = new FormData();
      formData.append('multipartFile', file);

      return this.httpClient.post<ResponseDto<Base64Carrier>>(this.url.concat('/comprimir'), formData)
        .pipe(
          finalize(()=>{this.loadingService.deactivate()}),
          switchMap((res) => {
            this.snackbarService.showSuccess("Arquivo comprimido com sucesso.");
            return of(res.response.content);
          }),
          catchError((err) => {
            this.snackbarService.showDanger("Erro ao comprimir arquivo.");
            return throwError(() => err);
          })
        );
    }

    return this.readAsBase64(file);
  }

  private readAsBase64(file: File): Observable<string> {

    return new Observable<string>((observer) => {
      const reader = new FileReader();
      reader.onload = () => observer.next(reader.result as string);
      reader.onerror = (err) => observer.error(err);
      reader.readAsDataURL(file);
    })
  }
}

export interface Base64Carrier {
  content: string;
  format: string;
}
